<template>
  <div>
    <el-dialog :visible.sync="diaShow" title="批量录入订单" width="650px" custom-class="dialog-body-paddingTop-10" @close="close" v-loading="importExtendLoading">
      <div class="flex flex-align-center font-14" style="margin-left:30px">
        <div style="line-height:30px">分销商：</div>
        <el-select v-model="distributor" style="width:380px" filterable :disabled="userInfo.IsDistribution"
          placeholder="请选择分销商">
          <el-option v-for="(v,i) in distributorList" :key="i" :value="v.Id" :label="v.EmployeeName"></el-option>
        </el-select>
      </div>
			<div v-if="extendFile.IsExistProgress" class="file-box">
				<div class="flex flex-align-center flex-column" v-if="!extendFile.IsComplete">
					<div class="flex flex-align-center">
						<img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/melyshop/image/exce-distributionInquiry20240513.png" style="width:30px" alt="">
						<div class="margin-left-20 margin-right-20 loading">
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
						<img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/melyshop/image/XT-qidian.png" style="width:30px" alt="">
					</div>
					<div style="text-align:center">
						<div class="color-606266 margin-top-20">数据导入中...</div>
						<div class="color-999999 margin-top-10">导入需要一定时间，请勿关闭操作框</div>
					</div>
				</div>
				<div style="text-align:center" v-else>
					<div class="color-606266">导入完成</div>
					<div class="color-999999 margin-top-10">成功导入{{extendFile.SuccessCount}}条</div>
					<!-- <el-button class="margin-top-20" v-if="extendFile.FailCount>0" @click="getresult(extendFile.importId,true)">下载导入失败数据</el-button> -->
				</div>
			</div>
			<el-upload :action="uploadFile" accept=".xls,.xlsx" class="file-box" :show-file-list="false" :before-upload="beforeUpload"
				 :on-success="handleUploadSuccess" v-else>
				<div v-if="extendFile.filePath" class="color-999999">
					<i class="el-icon-document"></i>
					<div class="margin-top-10 margin-bottom-20">{{extendFile.fileName}}</div>
				</div>
				<div v-else class="color-999999">
					<div>
						点击按钮上传文件，
					</div>
					<div class="margin-top-10 margin-bottom-10">
						支持xls、xlsx格式
					</div>
				</div>
				<el-button>上传文件</el-button>
			</el-upload>
			<div style="text-align:center" class="margin-top-30">
				<el-button type="primary" style="width:300px" v-if="hasConfirmBtn" @click="confirmImport">确认导入</el-button>
			</div>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/config/index';
import {
  cittaDistributiondistributorList,
  cittaDistributionOrderimport
} from "@/api/sv3.0.0"
import {
  employeeloginEmployeeInfo
} from "@/api/login"
export default {
  props:{
    show:{
      type:Boolean,
      default:false,
    }
  },
  watch:{
    show(val){
      this.diaShow = val
      this.getdistributorList()
      this.getUserInfo()
    }
  },
  data () {
    return {
      diaShow:false,
      distributor:'',
      distributorList:[],
      uploadFile: config.UPLOAD_ZIP,
      extendFile: {
        filePath:'',
        fileName:'',
        importId:0,
        SuccessCount:0,
        FailCount:0,
        IsComplete:false,
        IsExistProgress:false,
      },
      hasConfirmBtn: false,
      importExtendLoading: false,
      timeOut: null,
      userInfo:{},
    }
  },
  methods: {
    
    async getUserInfo(){
      try{
        let res = await employeeloginEmployeeInfo({})
        if(res.IsSuccess){
          this.userInfo = res.Result
          if(this.userInfo.IsDistribution){
            this.distributor = this.userInfo.EmployeeId
          }
        }
      }finally{
        //
      }
    },
    async getdistributorList(){
      try{
        let res = await cittaDistributiondistributorList({
          EmployeeState:1,
          Skip:0,
          Take:99999
        })
        if(res.IsSuccess){
          this.distributorList = res.Result.Results
        }
      }finally{
        //
      }
    },
    async confirmImport(){
      try{
        this.extendFile.IsExistProgress = true
        this.hasConfirmBtn = false
        let res = await cittaDistributionOrderimport({
          EmployeeId:this.distributor,
          ExcelFilePath:this.extendFile.filePath,
          ExcelFileName:this.extendFile.fileName,
        })
        if(res.IsSuccess){
          this.extendFile.IsComplete = true
          this.extendFile.SuccessCount = res.Result.ImportCount
        }
      }catch{
        this.extendFile.IsExistProgress = false
        this.hasConfirmBtn = true
      } finally{
        // this.hasConfirmBtn = true
      }
    },
    async getResult(){
      try{
        let res = await ({
          Id:this.extendFile.importId
        })
        if(res.IsSuccess){
          if(res.Result.IsComplete){
            for(let key in res.Result){
              this.extendFile[key] = res.Result[key]
            }
          }else{
            this.timeOut = setTimeout(()=>{
              this.getResult()
            },1000)
          }
        }
      }finally{
    
      }
    },
    handleUploadSuccess(file){
      this.extendFile.filePath = file[0]
      this.hasConfirmBtn = true
    },
    beforeUpload(file){
      var type = file.name.split('.')[file.name.split('.').length-1];
      if (['xls', 'xlsx'].indexOf(type) > -1){
        this.extendFile.fileName = file.name;
        return true;
      }else{
        this.$message.error('请选择正确的文件上传')
        return false;
      }
    },
    close(e){
      this.distributor = null
      this.extendFile = {
        filePath:'',
        fileName:'',
        importId:0,
        SuccessCount:0,
        FailCount:0,
        IsComplete:false,
        IsExistProgress:false,
      }
      this.hasConfirmBtn = false;
      clearTimeout(this.timeOut)
      this.$emit('close',false)
    }
  }
}
</script>

<style lang='less' scoped>

.file-box{
	border: 1px solid #DCDFE6;
	width: 500px;
	height: 172px;
	margin: 20px auto;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>